import React from "react";
import {BsCheck2} from "react-icons/bs";
const CheckPoint = ({title}) => {
  return (
    <div>
      <div className="flex pb-6">
        <div>
          <span>
            <BsCheck2 className="text-lg w-8 h-8 text-white bg-secondary rounded-full p-1 shadow-lg " />
          </span>
        </div>
        <div className="flex self-center">
          <span className="text-base text-dark font-normal pl-3">{title}</span>
        </div>
      </div>
    </div>
  );
};

export default CheckPoint;
